<template>
  <div id="accordion" class="w-100">
    <div class="d-flex" v-if="campaigns.length > 0">
      <span class="mx-2" v-for="(item, i) in totals.filter(el => el.qty != '0')" :key="i">
        <Tooltip
          :text="item.description"
          :width="'130px'"
        >
          <i class="icon-circle " :class="item.class"></i>
          {{ item.qty }}
        </Tooltip>
      </span>
    </div>
  </div>
</template>

<script>

import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  data () {
    return {
      totals: [
        { description: "pending", qty: 0, class: "text-warning" },
        { description: "active", qty: 0, class: "text-success" },
        { description: "stopped", qty: 0, class: "text-danger" },
        { description: "deleted", qty: 0, class: "text-info" },
      ]
    }
  },

  props: {
    campaigns: {
      type: Array,
      default: () => [],
    }
  },

  components: { Tooltip },


  created() {
    this.totals[0].qty = this.campaigns.filter( el => el.campaign_status_id === "1").length;
    this.totals[1].qty = this.campaigns.filter( el => el.campaign_status_id === "2").length;
    this.totals[2].qty = this.campaigns.filter( el => el.campaign_status_id === "3").length;
    this.totals[3].qty = this.campaigns.filter( el => el.campaign_status_id === "4").length;
  },
  methods:{

  }

};
</script>
